import saveUserToLocal from "@/common/function/saveUserToLocal";
import { generalRequest } from "@/utils/generalRequest";
import * as userRequest from "@/utils/userRequest";
import axios from "axios";

export default async function loginAPPService(teleId: string, type: string, key: string, new_key?: boolean) {
    try {
        const res = await axios.post(
            `/api/login?key=accountInfo-${type}`,
            {
                key,
                type,
                new_key,
                teleId,
            },
            {
                headers: {
                    Authorization: `Basic ${process.env.NEXT_PUBLIC_BASIC_TOKEN}`,
                },
            }
        );
        if (res.status === 200 || (res.status === 201 && res.data?.status != "failed")) {
            return res.data;
        }
    } catch (error) {
        console.error("🚀 ~ loginAPPService ~ error:", error);
        throw error;
    }
}
